module.exports = __webpack_public_path__ + "static/media/ring.a14c1e01.mp3";